import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import ShowIfContext from '@sprinx/react-showif/ShowIfProvider/ShowIfContext';
import resolveShowIf from '@sprinx/react-showif/utils/resolveShowIf';
import LayoutWrapper from './LayoutWrapper';
import NotFoundRouteContent from './NotFoundRouteContent';
/**
 * Pomocna komponenta pro routy. Vysporadava se z podminenym zobrazenim obsahu na zaklade podminek
 * v `showIf` properte.
 */

function RouteContent(_ref) {
  var showIf = _ref.showIf,
      props = _objectWithoutProperties(_ref, ["showIf"]);

  var showIfCtx = React.useContext(ShowIfContext);
  var allow = showIfCtx ? resolveShowIf(showIfCtx, showIf) : true;
  var C = allow ? LayoutWrapper : NotFoundRouteContent;
  return React.createElement(C, props);
}

RouteContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  component: PropTypes.elementType,
  layout: PropTypes.elementType,
  render: PropTypes.func,
  renderNotFound: PropTypes.func,
  showIf: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.func])
};
RouteContent.defaultProps = {
  children: null,
  component: null,
  layout: null,
  render: null,
  renderNotFound: null,
  showIf: true
};
export default RouteContent;